import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSchema } from '../store/selectors';
import CalculationEditor from './CalculationEditor';
import FieldSelect from './FieldSelect';
import { FieldReferenceMap } from './types';
import { mapSchemaFieldsToReference } from './utils';

function CWTCalculations(): JSX.Element {
    const schema = useSelector(selectSchema);
    const [selectedReferenceMap, setSelectedReferenceMap] = useState<FieldReferenceMap>();
    const references = useMemo(() => mapSchemaFieldsToReference(schema), [schema]);

    return (
        <div>
            <div className="flex flex-col gap-6 mx-auto w-[650px] mt-4">
                {references.length > 0 && <FieldSelect references={references} onChange={setSelectedReferenceMap} />}
                {selectedReferenceMap && (
                    <CalculationEditor schema={schema} references={references} selectedReference={selectedReferenceMap} />
                )}
            </div>
        </div>
    );
}

export default CWTCalculations;
